import { inject, observer } from 'mobx-react';
import Component from './component';

const mapProps = ({ Store }) => ({
  isExistImagePreviewData: Store.imagePreviewData !== null,
  isShowConfirmSessDel: Store.windowConfirmData !== null,
  isShowConfirmMessDel: Store.deleteMessageId !== null,
});
export default inject(mapProps)(observer(Component));
